import { Construtor } from './construtor';

export class FiltroOcorrencia implements Construtor<FiltroOcorrencia> {

  public idCliente: number;
  public idTipoOcorrencia: number;
  public nomePontoFisico: string;
  public descricaoStatusOcorrencia: string;
  public descricaoTipoOcorrencia: string;
  public origem: string;
  public dataInicioReferencia: Date;
  public dataFimReferencia: Date;
  public diaOcorrencia: Date;

  constructor(object?: any) {

    if (object !== undefined) {

      if (object instanceof FiltroOcorrencia) {
        this.copyObject(object);
      } else {
        this.parseFromJson(object);
      }

      if (!this.modeloCompleto()) {
        return null;
      }
    }

    return this;
  }

  copyObject(ocorrencia: FiltroOcorrencia): void {
    this.idCliente = ocorrencia.idCliente;
    this.idTipoOcorrencia = ocorrencia.idTipoOcorrencia;
    this.nomePontoFisico = ocorrencia.nomePontoFisico;
    this.descricaoStatusOcorrencia = ocorrencia.descricaoStatusOcorrencia;
    this.descricaoTipoOcorrencia = ocorrencia.descricaoTipoOcorrencia;
    this.dataInicioReferencia = ocorrencia.dataInicioReferencia;
    this.dataFimReferencia = ocorrencia.dataFimReferencia;
    this.diaOcorrencia = ocorrencia.diaOcorrencia;
    this.origem = ocorrencia.origem;
  }

  parseFromJson(ocorrencia: any): void {
    this.idCliente = ocorrencia.idCliente;
    this.idTipoOcorrencia = ocorrencia.idTipoOcorrencia;
    this.nomePontoFisico = ocorrencia.nomePontoFisico;
    this.descricaoStatusOcorrencia = ocorrencia.descricaoStatusOcorrencia;
    this.descricaoTipoOcorrencia = ocorrencia.descricaoTipoOcorrencia;
    this.dataInicioReferencia = ocorrencia.dataInicioReferencia;
    this.dataFimReferencia = ocorrencia.dataFimReferencia;
    this.diaOcorrencia = ocorrencia.diaOcorrencia;
    this.origem = ocorrencia.origem;
  }

  modeloCompleto(): boolean {
    return this.idCliente !== undefined &&
      this.idTipoOcorrencia !== undefined;
  }

  getNewInstance(object?: any): FiltroOcorrencia {
    return new FiltroOcorrencia(object);
  }
}



// WEBPACK FOOTER //
// C:/Development/Projects/Sun/Flag/workspace/flagvarejoang4/src/app/comum/modelos/filtro-ocorrencia.ts